import React, { useState, useEffect } from "react";
import Icon from "./AppIcon";
import { getExchangeRate } from "../services/api";

const LiveExchangeRate = ({ compact }) => {
  const [rate, setRate] = useState(null);
  const [source, setSource] = useState("");

  useEffect(() => {
    let mounted = true;
    getExchangeRate().then((data) => {
      if (!mounted) return;
      setRate(data.rate);
      setSource(data.source);
    });
    return () => { mounted = false; };
  }, []);

  if (!rate) return null;

  const sourceIcon = source === "live" ? "Wifi" : source === "cache" ? "Clock" : "AlertCircle";

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 text-sm font-medium">
        <Icon name="DollarSign" size={13} className="text-green-500" />
        1 USD = {rate.toFixed(2)} NPR
      </span>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-xl text-sm">
      <Icon name="DollarSign" size={16} className="text-green-600" />
      <span className="font-semibold text-green-800">Live Rate:</span>
      <span className="text-green-700">1 USD = <strong>{rate.toFixed(2)} NPR</strong></span>
      <Icon name={sourceIcon} size={12} className="text-green-400 ml-1" title={`Source: ${source}`} />
    </div>
  );
};

export default LiveExchangeRate;
